
import { computed, defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// components
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import Modal from '@/common/components/UI/Modal/index.vue'

// types
import { CourierT } from '@/core/types/couriers.types'

// realisation
import { carriers } from '@/core/realisations/carriers.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

// constants
import { CarriersSendColumns } from '@/core/constants/columns/Carriers.columns'
import { companies } from '@/core/realisations/companies.realisation'

export default defineComponent({
    emits: ['cancel'],
    components: {
        TheTable,
        TableScrollWrapper,
        Modal,
    },
    props: {
        id: {
            type: Number,
            default: null,
        },
        bin: {
            type: String,
            default: null,
        },
        couriers: {
            type: Array as PropType<CourierT[]>,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_active: false,
        })

        const getContractInformation = async () => {
            try {
                state.is_loading = true

                const response = await carriers.getContractInformation(props.bin)

                if (response.success) {
                    state.is_active = true
                }
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При получении информации произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const emitCancel = () => {
            emit('cancel')
        }

        const sendToContract = async () => {
            if (state.is_loading) return

            try {
                state.is_loading = true

                await companies.sendToContract(props.id)
                notifications.notify({
                    title: 'Отправлено',
                    description: 'Список курьеров отправлен на подпись',
                    type: 'success',
                })

                emitCancel()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При отправке списка курьеров произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const getIndex = (index: string) => {
            return Number(index.split('-')[0]) + 1
        }

        onBeforeMount(() => {
            getContractInformation()
        })

        const isCouriers = computed(() => {
            return props.couriers && props.couriers.length
        })

        return {
            state,
            CarriersSendColumns,
            emitCancel,
            sendToContract,
            getIndex,
            //
            isCouriers,
        }
    },
})
